import GestSelect from '@shared/library/dist/components/gest/GestInputs/select/GestSelect';
import { IGestSelectOption } from '@shared/library/dist/components/gest/GestInputs/select/GestSelectProps';
import GestSwitch from '@shared/library/dist/components/gest/GestInputs/switch/GestSwitch';
import GestTextArea from '@shared/library/dist/components/gest/GestInputs/text area/GestTextArea';
import React from 'react';

const UserCreateForm = (props: { roles?: IGestSelectOption<undefined>[]; }) =>
    <>
        <GestTextArea fullw name="Firstname" label="Nome" required minLen={3} />
        <GestTextArea fullw name="Lastname" label="Cognome" required minLen={3} />
        <GestTextArea fullw name="Email" label="E-mail" required type='email' minLen={6} />
        <GestTextArea fullw name="Username" label="Username" required minLen={3} />
        <GestTextArea fullw name="Password" label="Password" required type='password' minLen={8} />
        <GestSelect
            fullw
            required
            name="Role"
            label="Ruolo"
            value={props.roles?.length ? props.roles[props.roles.length - 2].value : undefined}
            options={props.roles}
        />
        <label><GestSwitch name="SendEmail" checked={true} />&nbsp;Invia credenziali per email</label>
        <label><GestSwitch name="Status" checked={true} />&nbsp;Abilita Web Gest</label>
    </>;
export default React.memo(UserCreateForm);